import React from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import pxToRem from "libs/pxToRem";

const StyledTitle = styled(Typography)({
  fontSize: pxToRem(35.2),
  color: "#fff",
  marginBottom: pxToRem(20),
  fontWeight: 700,
  letterSpacing: 0,
});

const SecondaryTitle: React.FC<{ label: string }> = ({ label }) => (
  <StyledTitle variant="h1">{label}</StyledTitle>
);

export default SecondaryTitle;
